<template>
	<b-modal hide-footer id="editCfContactModal" :title="`Update ${modalTitle}`" @shown="focusMyElement">
		<ValidationObserver v-slot="{ invalid }" ref="form">
			<div class="row" v-if="contactData">
				<div class="col-md-6">
					<div class="form-group">
						<label>First Name</label>
						<b-form-input type="text" v-model="contactData.first_name" v-on:keyup.enter="saveContactFn"
							ref="focusThis" lazy-formatter :formatter="Format.titleCase" />
					</div>
				</div>
				<div class="col-md-6">
					<div class="form-group">
						<label>Last Name</label>
						<b-form-input type="text" v-model="contactData.last_name" v-on:keyup.enter="saveContactFn"
							lazy-formatter :formatter="Format.titleCase" />
					</div>
				</div>
				<div class="col-md-6">
					<div class="form-group">
						<label>Title</label>
						<b-form-input type="text" v-model="contactData.position" v-on:keyup.enter="saveContactFn"
							lazy-formatter :formatter="Format.titleCase" />
					</div>
				</div>
				<div class="col-md-6">
					<div class="form-group">
						<label>{{ deliverableContactCompanyLabel(deliverableDetail.deliverable_template_id) }}</label>
						<b-form-input type="text" v-model="contactData.company_name" v-on:keyup.enter="saveContactFn" />
					</div>
				</div>
				<div class="col-md-6">
					<div class="form-group">
						<label>Email</label>
						<b-form-input type="email" v-model="contactData.email_address" v-on:keyup.enter="saveContactFn"
							lazy-formatter :formatter="Format.email" />
					</div>
				</div>
				<div class="col-md-6">
					<div class="form-group">
						<label>Phone</label>
						<b-form-input type="text" v-model="contactData.phone" v-on:keyup.enter="saveContactFn"
							lazy-formatter :formatter="Format.phone" />
					</div>
				</div>
				<div class="col-md-6">
					<div class="form-group">
						<label>Mobile</label>
						<b-form-input type="text" v-model="contactData.cell_phone" v-on:keyup.enter="saveContactFn"
							lazy-formatter :formatter="Format.phone" />
					</div>
				</div>
				<div class="col-md-6">
					<div class="form-group">
						<label>Fax</label>
						<b-form-input type="text" v-model="contactData.fax_number" v-on:keyup.enter="saveContactFn"
							lazy-formatter :formatter="Format.phone" />
					</div>
				</div>
				<div class="col-md-12">
					<div class="form-group">
						<label>Website</label>
						<b-form-input type="url" v-model="contactData.website" v-on:keyup.enter="saveContactFn"
							lazy-formatter :formatter="Format.website" />
					</div>
				</div>
				<div class="col-md-12">
					<div class="form-group">
						<label>Address</label>
						<b-form-input type="text" class="form-control" v-model="contactData.address"></b-form-input>
					</div>
				</div>
				<div class="col-md-6">
					<div class="form-group">
						<label>City</label>
						<b-form-input type="text" v-model="contactData.city" v-on:keyup.enter="saveContactFn"
							lazy-formatter :formatter="Format.city" />
					</div>
				</div>
				<div class="col-md-6">
					<div class="form-group">
						<label>Country</label>
						<multiselect v-model="contactData.country_id" :options="allCountries" :multiple="false"
							@input="filterState"></multiselect>
					</div>
				</div>
				<div class="col-md-6">
					<div class="form-group">
						<label>Province</label>
						<multiselect v-model="contactData.province" :options="filteredStates" :multiple="false">
						</multiselect>
					</div>
				</div>
				<div class="col-md-6">
					<div class="form-group">
						<label>Postal Code</label>
						<b-form-input type="text" v-model="contactData.postal_code" v-on:keyup.enter="saveContactFn"
							lazy-formatter :formatter="Format.postalCode" />
					</div>
				</div>

				<div class="col-md-6" v-for="(obj, index) in cfChildren" :key="index">
					<div class="form-group">
						<label>{{ obj.label }}</label>
						<multiselect v-if="obj.field_type == 'select'" v-model="selectedValues[obj.field_key]"
							:options="getOptions(obj.value_set)" :multiple="!!obj.is_multiple" label="name"
							track-by="slug" :show-labels="false" :allow-empty="false" :close-on-select="true"
							@select="selectRole">
						</multiselect>
					</div>
				</div>
				<div class="col-md-12">
					<div class="form-group">
						<label>Notes</label>
						<b-form-textarea class="form-control" v-model="contactData.notes"></b-form-textarea>
					</div>
				</div>
				<div class="col-md-12">
					<div class="row" v-show="showErrorAlert">
						<div class="col">
							<b-alert v-model="showErrorAlert" variant="danger">There is a problem with the information
								entered above.</b-alert>
						</div>
					</div>
					<div class="row">
						<div class="col">
							<button class="btn btn-primary" type="button" @click="saveContactFn"
								data-dismiss="modal">Save</button>
						</div>
						<div class="col text-right">
							<button class="btn btn-text" type="button" @click="removeContactFn"
								data-dismiss="modal">Remove
								from call</button>
						</div>
					</div>


				</div>
			</div>
		</ValidationObserver>
	</b-modal>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Format from "../../utility/Format";

export default {
	data() {
		return {
			modalTitle: "",
			cfChildren: [],
			filteredStates: [],
			Format,
			showErrorAlert: false,
			selectedValues: {},
		};
	},
	props: ["namespace"],
	computed: {
		...mapState({
			state(state) {
				return state[this.namespace]
			},
			allCountries(state, getters) {
				return getters['allCountries']
			},
			allStates(state, getters) {
				return getters['allStates']
			},
			deliverableDetail(state, getters) {
				return getters[this.namespace + 'deliverableDetail']
			},
			deliverableContactsLabel(state, getters) {
				return getters[this.namespace + 'deliverableContactsLabel']
			},
			deliverableContactCompanyLabel(state, getters) {
				return getters[this.namespace + 'deliverableContactCompanyLabel']
			},
			currentFieldKey(state, getters) {
				return getters[this.namespace + 'currentFieldKey']
			},
			currentContactData(state, getters) {
				return getters[this.namespace + 'currentContactData']
			},
			currentContactTemplateType(state, getters) {
				return getters[this.namespace + 'currentContactTemplateType']
			},
			deliverableId(state, getters) {
				return getters[this.namespace + 'deliverableId']
			},
			projectDetail(state, getters) {
				return getters[this.namespace + 'projectDetail']
			},
		}),
		contactData() {
			return this.currentContactData;
		}
	},
	methods: {
		focusMyElement() {
			this.setModalTitle(this.currentFieldKey);
			this.$refs.focusThis.focus();
		},
		selectRole(selectedOption, id) {
			this.$set(this.selectedValues, "main_participants_role", selectedOption);
		},
		saveContactFn() {
			if (this) {
				let that = this;
				this.$refs.form.validate().then(success => {
					if (!success) {
						that.showErrorAlert = true;
						return;
					}
					that.showErrorAlert = false;
					let deliverableId = this.deliverableDetail.deliverableId,
						contactFieldChildren = this.selectedValues,
						projectId = this.projectDetail.projectId,
						currentContactTemplateType = this.currentContactTemplateType;
					let payload = {
						...that.contactData,
						deliverableId,
						contactFieldChildren,
						projectId,
						currentContactTemplateType,
					}
					let action = "updateCfContact";
					if (currentContactTemplateType == "project") {
						action = "updateProjectCfContact";
					}
					that.$store.dispatch(action, payload);
					that.$bvModal.hide('editCfContactModal')
				});
			}
		},
		removeContactFn() {
			if (this.contactData.id) {
				let action = "removeDeliverableCfContact",
					belongsToId = this.deliverableDetail.deliverableId,
					currentFieldKey = this.currentFieldKey;
				if (this.currentContactTemplateType == "project") {
					action = "removeProjectCfContact";
					belongsToId = this.projectDetail.projectId;
				}
				let payload = {
					contactId: this.contactData.id,
					belongsToId,
					currentFieldKey,
				}
				this.$store.dispatch(action, payload);
			}
			this.$bvModal.hide('editCfContactModal')
		},
		filterState() {
			if (this.contactData) {
				let allStatesData = this.allStates,
					usStates = allStatesData.slice(0, 50),
					canadaStates = allStatesData.slice(51);
				this.filteredStates =
					this.contactData.country_id == "Canada" ? canadaStates : usStates;
			}
		},
		getOptions(valueSet) {
			let parsed = this.parseValue(valueSet);
			if (parsed == false) {
				return [];  // if we don't check for false... it thows up errors
			} else {
				// build value and text
				return parsed;
			}
		},
		parseValue(str) {
			try {
				return JSON.parse(str);
			} catch (e) {
				return false;
			}
		},
		setModalTitle(currentFieldKey) {
			if (currentFieldKey) {
				let templateCustomFields = this.deliverableDetail.templateCustomFields;
				if (this.currentContactTemplateType == "project") {
					templateCustomFields = this.projectDetail.projectCustomFields;
				}
				console.log("currentContactTemplateType", this.currentContactTemplateType)
				const objectWithFieldKey = templateCustomFields.find(obj => {
					return obj.field_key === currentFieldKey;
				});
				this.modalTitle = objectWithFieldKey.label;
				console.log("modalTitle", this.modalTitle)
				if (objectWithFieldKey.children) {
					this.cfChildren = objectWithFieldKey.children;
					objectWithFieldKey.children.forEach(child => {
						if (child.properties_set && child.field_type == "select") {
							// Set default value for multiselect from DB
							this.$set(this.selectedValues, child.field_key, this.currentContactData.children[0]);
						}
					});
				} else {
					//Reset selectedValues, so not passed in API
					this.selectedValues = {};
				}
			}
		},
	},
	created() {
		this.filterState();
	}
};
</script>

<style></style>